import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResumeCurrentMobileDayComponent } from './resume-current-mobile-day.component';
import { CardComponent } from '../../@theme/components/card/card.component';
import { DurationTextModule } from '../duration-text';
import { FindOfArrayPipe, RenderDurationPipe } from '../../pipes';



@NgModule({
  declarations: [
    ResumeCurrentMobileDayComponent
  ],
  exports: [
    ResumeCurrentMobileDayComponent
  ],
  imports: [
    CommonModule,
    CardComponent,
    DurationTextModule,
    RenderDurationPipe,
    FindOfArrayPipe
  ]
})
export class ResumeCurrentMobileDayModule { }
